import { gql } from "@apollo/client";

export const DRIVER_QUERY = gql`
  query driver($uniqueID: String!) {
    driver(uniqueID: $uniqueID) {
      id
      uniqueID
      firstName
      lastName
      phoneNumber
      phoneCountryCode
      identityCardNo
    }
  }
`;

export const DRIVERS_QUERY = gql`
  query driverData($documentId: Int!) {
    driverData(documentId: $documentId) {
      documentId
      drivers {
        id
        uniqueID
        firstName
        lastName
        phoneNumber
        phoneCountryCode
        identityCardNo
        agreesWithPersonalDataUse
      }
    }
  }
`;
